export default __webpack_public_path__ + "static/media/ultima_logo.35bc41b2.png";